export const leadFilters = [
  "APP_EHC",
  "APP_ASSESSMENT",
  "WEB_EHC",
  "WEB_ASSESSMENT",
  "MMT",
  "HOPE"
];

export const customerFilters = ["APP", "WEB", "OTHER"];

export const leadStatus = [
  "HOT",
  "WARM",
  "COLD",
];

export const customerStatus = ["SINGLE", "SUBSCRIPTION"];

export const systemUsageFilters = Array.from({ length: 11 }, (_, i) => {
  const val = (i).toString();
  return { value: val, label: val };
});

export const languagesOptions = [
  { value: "hindi", label: "Hindi" },
  { value: "english", label: "English" },
  { value: "kannada", label: "Kannada" },
  { value: "tamil", label: "Tamil" },
  { value: "marathi", label: "Marathi" },
  { value: "malyalam", label: "Malyalam" },
  { value: "gujarati", label: "Gujarati" },
  { value: "bengali", label: "Bengali" },
  { value: "telugu", label: "Telugu" },
  { value: "punjabi", label: "Punjabi" },
  { value: "nepali", label: "Nepali" },
  { value: "urdu", label: "Urdu" },
  { value: "other", label: "Other" },
];

export const genderOptions = [
  { value: "male", label: "Male" },
  { value: "female", label: "Female" },
  { value: "non-binary", label: "Non Binary" },
  { value: "others", label: "Other" },
];


export const budgetOptions = [
  { value: "0", label: "Free" },
  { value: "<750", label: "Less than 750" },
  { value: ">750", label: "More than 750" },
  { value: ">1000", label: "More than 1000" },
]


export const issuesOptions = [
  { value: "anxiety", label: "Anxiety" },
  { value: "Crying spells", label: "Crying Spells" },
  { value: "depressed_mood", label: "Depressed Mood" },
  { value: "grief", label: "Grief" },
  { value: "feeling_low", label: "Feeling Low" },
  { value: "understand_my_issue", label: "Understand my issue" },
  { value: "overwhelming_sadness", label: "Overwhelming Sadness" },
  { value: "unable_to_enjoy_activities", label: "Unable To Enjoy Activities" },
  { value: "decreased_need_for_sleep", label: "Decreased Need For Sleep" },
  { value: "loss_of_interest", label: "Loss of interest" },
  {
    value: "difficulties_in_concentration",
    label: "Difficulties In Concentration",
  },
  { value: "increase_in_appetite", label: "Increase In Appetite" },
  { value: "decrease_in_appetite", label: "Decrease In Appetite" },
  { value: "excessive_guilt", label: "Excessive Guilt" },
  { value: "increased_irritability", label: "Increased Irritability" },
  { value: "racing_thoughts", label: "Racing thoughts" },
  { value: "impulsivity", label: "Impulsivity" },
  { value: "panic _attacks", label: "Panic Attacks" },
  { value: "unexplained_fears", label: "Unexplained Fears" },
  { value: "excessive_worrying", label: "Excessive Worrying" },
  { value: "avoidance", label: "Avoidance" },
  { value: "hallucinations", label: "Hallucinations" },
  { value: "suspiciousness", label: "Suspiciousness" },
  { value: "increased_libido", label: "Increased Libido" },
  { value: "decreased_libido", label: "Decreased Libido" },
  { value: "relationship", label: "Relationship" },
  { value: "breakup", label: "Breakup" },
  { value: "family_issues", label: "Family Issues" },
  { value: "overthinking", label: "Overthinking" },
  { value: "clinical_disorders", label: "Clinical Disorders" },
  { value: "suicidal_ideations", label: "Suicidal Ideations" },
  { value: "loneliness", label: "Loneliness" },
  { value: "procrastination", label: "Procrastination" },
  { value: "increased_need_for_sleep", label: "Increased Need For Sleep" },
  { value: "work_stress", label: "Work Stress" },
  { value: "exam_stress", label: "Exam Stress" },
  { value: "self_esteem", label: "Self Esteem" },
  { value: "trauma", label: "Trauma" },
  { value: "self_harm", label: "Self Harm" },
  { value: "addiction", label: "Addiction" },
  { value: "depression", label: "Depression" },
  { value: "student_career ", label: "  Student Career " },
  { value: "intimacy", label: "Intimacy" },
  { value: "founder_stress", label: "Founder Stress" },
  { value: "ptsd", label: "PTSD" },
  { value: "low_confidence", label: "Low Confidence" },
  { value: "mood_swings", label: "Mood Swings" },
  { value: "low_motivation", label: "Low Motivation" },
  { value: "work_life_balance", label: "Work life balance" },
  { value: "sexual_dysfunction", label: "Sexual Dysfunction" },
  //new
  { value: "personality_disorder", label: "Personality Disorder" },
  { value: "marital_discorder", label: "Marital Discorder" },
  { value: "behavioural_problems", label: "Behavioural Problems" },
  {
    value: "obsessive_compulsive_disorder",
    label: "Obsessive Compulsive Disorder (OCD)",
  },
  { value: "insomnia", label: "Insomnia" },
  { value: "anger_management", label: "Anger Management" },
  { value: "attachment_problems", label: "Attachment Problems" },
  { value: "couple_counseling", label: "Couple Counseling" },
  { value: "eating_disorder", label: "Eating Disorder" },
  { value: "existential_crisis", label: "Existential Crisis" },
  { value: "academic_stress", label: "Academic Stress" },
  { value: "time_management", label: "Time Management" },
  {
    value: "emotionally_unstable_personality_disorder",
    label: "Emotionally Unstable Personality Disorder (EUPD)",
  },
  { value: "phobias", label: "Phobias" },
  { value: "negative_thoughts", label: "Negative Thoughts" },
  { value: "mindfulness", label: "Mindfulness" },
  { value: "body_image", label: "Body Image" },
  { value: "ADHD", label: "ADHD" },
  { value: "dissociative_disorder", label: "Dissociative Disorder" },
  { value: "special_needs", label: "Special Needs" },
  { value: "career_concerns", label: "Career Concerns" },
  { value: "suicide_prevention", label: "Suicide Prevention" },
  { value: "postpartum_depression", label: "Postpartum Depression" },
  { value: "depressive_thoughts", label: "Depressive Thoughts" },
  { value: "anxious_thoughts", label: "Anxious Thoughts" },
  { value: "yoga", label: "Yoga" },
  { value: "miscarriages_and_abortions", label: "Miscarriages and Abortions" },
  { value: "issues_of_adjustment", label: "Issues of Adjustment" },
  { value: "other", label: "Others" },
];